type UniqueKeyOption = {
    base?: number
    length?: number
}
/** 임의 문자열 생성 */
export const getUniqueKey = (option?: UniqueKeyOption): string => {
    const base = option?.base ?? 36
    const startIndex = 2
    const endIndex = startIndex + Math.abs(option?.length ?? 6)
    return Math.random().toString(base).substring(startIndex, endIndex)
}

/** uuid 생성 */
export const getUUID = () => {
    // iOS 15.x 환경을 위해 대응 15,4 부터 지원
    if (!(crypto && 'randomUUID' in crypto)) {
        // @see https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid/8809472#8809472
        let d = new Date().getTime() // Timestamp
        let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0 // Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 // random number between 0 and 16
            if (d > 0) {
                r = ((d + r) % 16) | 0
                d = Math.floor(d / 16)
            } else {
                r = ((d2 + r) % 16) | 0
                d2 = Math.floor(d2 / 16)
            }
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
        })
    }
    return crypto.randomUUID()
}
